export default function AddData() {
  return (
    <>
      <div className="px-4">
        <h3>Add Data</h3>
        <div className="card p-3 mt-3">
          <input className="form-control mb-2" placeholder="Name" />
          <button className="btn btn-success">Save</button>
        </div>
      </div>
    </>
  );
}
